import clsx from 'clsx'
import React, { FC } from "react"
import ReactDOM from "react-dom"
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"

import { ModalProps } from "../../utils/Interfaces"
import { Thematic } from "../../components/utils/Thematic"

export const FullScreenModal: FC<ModalProps> = ({ show, showOrHide, execAction, content }) => {

    return ReactDOM.createPortal(
        <Dialog open={show} onClose={showOrHide} className="relative z-30">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 dark:bg-gray-800/80 backdrop-blur-sm bg-opacity-65 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen h-screen overflow-y-auto">
                <div className="flex h-full w-full items-end justify-center text-center sm:items-center">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden bg-white dark:bg-slate-800 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 w-full sm:top-0 sm:left-0 sm:right-0 sm:bottom-0 h-full rounded-none"
                    >
                        <Thematic>
                            <div className="flex flex-col w-full h-full">
                                

                                {/* Scrollable Section (Only on md+ screens) */}
                                <div className="flex-1 overflow-auto md:overflow-y-auto">
                                    {content}
                                </div>

                                {/* Bottom Section (Non-Scrollable) */}
                                {
                                    execAction
                                }
                            </div>
                        </Thematic>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>,
        document.getElementById('root')
    )
}
